export const POST_LOGIN_REQUEST = "POST_LOGIN_REQUEST";
export const POST_LOGIN_SUCCESS = "POST_LOGIN_SUCCESS";
export const POST_LOGIN_ERROR = "POST_LOGIN_ERROR";

export const GET_SUBSCRIPTION_PLAN_REQUEST = "GET_SUBSCRIPTION_PLAN_REQUEST";
export const GET_SUBSCRIPTION_PLAN_SUCCESS = "GET_SUBSCRIPTION_PLAN_SUCCESS";
export const GET_SUBSCRIPTION_PLAN_ERROR = "GET_SUBSCRIPTION_PLAN_ERROR";

export const SUBSCRIPTION_REQUEST = "SUBSCRIPTION_REQUEST";
export const SUBSCRIPTION_SUCCESS = "SUBSCRIPTION_SUCCESS";
export const SUBSCRIPTION_ERROR = "SUBSCRIPTION_ERROR";

export const GET_INFO_REQUEST = "GET_INFO_REQUEST";
export const GET_INFO_SUCCESS = "GET_INFO_SUCCESS";
export const GET_INFO_ERROR = "GET_INFO_ERROR";

export const GET_LOCATIONS_REQUEST = "GET_LOCATIONS_REQUEST";
export const GET_LOCATIONS_SUCCESS = "GET_LOCATIONS_SUCCESS";
export const GET_LOCATIONS_ERROR = "GET_LOCATIONS_ERROR";

export const TOKEN_REQUEST = "TOKEN_REQUEST";
export const TOKEN_SUCCESS = "TOKEN_SUCCESS";
export const TOKEN_ERROR = "TOKEN_ERROR";

export const GET_CONFIGURATION_REQUEST = "GET_CONFIGURATION_REQUEST";
export const GET_CONFIGURATION_SUCCESS = "GET_CONFIGURATION_SUCCESS";
export const GET_CONFIGURATION_ERROR = "GET_CONFIGURATION_ERROR";

export const GET_BARCODE_REQUEST = "GET_BARCODE_REQUEST";
export const GET_BARCODE_SUCCESS = "GET_BARCODE_SUCCESS";
export const GET_BARCODE_ERROR = "GET_BARCODE_ERROR";

export const PRINT_TAG_REQUEST = "PRINT_TAG_REQUEST";
export const PRINT_TAG_SUCCESS = "PRINT_TAG_SUCCESS";
export const PRINT_TAG_ERROR = "PRINT_TAG_ERROR";

export const SQUARE_REQUEST = "SQUARE_REQUEST";
export const SQUARE_SUCCESS = "SQUARE_SUCCESS";
export const SQUARE_ERROR = "SQUARE_ERROR";

export const GET_TEMPLATE_REQUEST = "GET_TEMPLATE_REQUEST";
export const GET_TEMPLATE_SUCCESS = "GET_TEMPLATE_SUCCESS";
export const GET_TEMPLATE_ERROR = "GET_TEMPLATE_ERROR";

export const GET_CATEGORIES_REQUEST = "GET_CATEGORIES_REQUEST";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_ERROR = "GET_CATEGORIES_ERROR";

export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_ERROR = "REGISTER_ERROR";

export const CONTACT_REQUEST = "CONTACT_REQUEST";
export const CONTACT_SUCCESS = "CONTACT_SUCCESS";
export const CONTACT_ERROR = "CONTACT_ERROR";

export const POST_FAQ_REQUEST = "POST_FAQ_REQUEST";
export const POST_FAQ_SUCCESS = "POST_FAQ_SUCCESS";
export const POST_FAQ_ERROR = "POST_FAQ_ERROR";

export const FAQ_SEARCH_REQUEST = "FAQ_SEARCH_REQUEST";
export const FAQ_SEARCH_SUCCESS = "FAQ_SEARCH_SUCCESS";
export const FAQ_SEARCH_ERROR = "FAQ_SEARCH_ERROR";

export const DELETE_FAQ_REQUEST = "DELETE_FAQ_REQUEST";
export const DELETE_FAQ_SUCCESS = "DELETE_FAQ_SUCCESS";
export const DELETE_FAQ_ERROR = "DELETE_FAQ_ERROR";

export const UPDATE_FAQ_REQUEST = "UPDATE_FAQ_REQUEST";
export const UPDATE_FAQ_SUCCESS = "UPDATE_FAQ_SUCCESS";
export const UPDATE_FAQ_ERROR = "UPDATE_FAQ_ERROR";

export const POST_SUBSCRIPTION_REQUEST = "POST_SUBSCRIPTION_REQUEST";
export const POST_SUBSCRIPTION_SUCCESS = "POST_SUBSCRIPTION_SUCCESS";
export const POST_SUBSCRIPTION_ERROR = "POST_SUBSCRIPTION_ERROR";

export const SUBSCRIPTION_SEARCH_REQUEST = "SUBSCRIPTION_SEARCH_REQUEST";
export const SUBSCRIPTION_SEARCH_SUCCESS = "SUBSCRIPTION_SEARCH_SUCCESS";
export const SUBSCRIPTION_SEARCH_ERROR = "SUBSCRIPTION_SEARCH_ERROR";

export const DELETE_SUBSCRIPTION_REQUEST = "DELETE_SUBSCRIPTION_REQUEST";
export const DELETE_SUBSCRIPTION_SUCCESS = "DELETE_SUBSCRIPTION_SUCCESS";
export const DELETE_SUBSCRIPTION_ERROR = "DELETE_SUBSCRIPTION_ERROR";

export const UPDATE_SUBSCRIPTION_REQUEST = "UPDATE_SUBSCRIPTION_REQUEST";
export const UPDATE_SUBSCRIPTION_SUCCESS = "UPDATE_SUBSCRIPTION_SUCCESS";
export const UPDATE_SUBSCRIPTION_ERROR = "UPDATE_SUBSCRIPTION_ERROR";

export const POST_VIDEO_REQUEST = "POST_VIDEO_REQUEST";
export const POST_VIDEO_SUCCESS = "POST_VIDEO_SUCCESS";
export const POST_VIDEO_ERROR = "POST_VIDEO_ERROR";

export const VIDEO_SEARCH_REQUEST = "VIDEO_SEARCH_REQUEST";
export const VIDEO_SEARCH_SUCCESS = "VIDEO_SEARCH_SUCCESS";
export const VIDEO_SEARCH_ERROR = "VIDEO_SEARCH_ERROR";

export const DELETE_VIDEO_REQUEST = "DELETE_VIDEO_REQUEST";
export const DELETE_VIDEO_SUCCESS = "DELETE_VIDEO_SUCCESS";
export const DELETE_VIDEO_ERROR = "DELETE_VIDEO_ERROR";

export const UPDATE_VIDEO_REQUEST = "UPDATE_VIDEO_REQUEST";
export const UPDATE_VIDEO_SUCCESS = "UPDATE_VIDEO_SUCCESS";
export const UPDATE_VIDEO_ERROR = "UPDATE_VIDEO_ERROR";

export const GET_SHOPIFY_LOCATIONS_REQUEST = "GET_SHOPIFY_LOCATIONS_REQUEST";
export const GET_SHOPIFY_LOCATIONS_SUCCESS = "GET_SHOPIFY_LOCATIONS_SUCCESS";
export const GET_SHOPIFY_LOCATIONS_ERROR = "GET_SHOPIFY_LOCATIONS_ERROR";

export const GET_PRODUCT_TYPE_REQUEST = "GET_PRODUCT_TYPE_REQUEST";
export const GET_PRODUCT_TYPE_SUCCESS = "GET_PRODUCT_TYPE_SUCCESS";
export const GET_PRODUCT_TYPE_ERROR = "GET_PRODUCT_TYPE_ERROR";

export const SHOPIFY_REQUEST = "SHOPIFY_REQUEST";
export const SHOPIFY_SUCCESS = "SHOPIFY_SUCCESS";
export const SHOPIFY_ERROR = "SHOPIFY_ERROR";

export const MODAL_OPEN = "MODAL_OPEN";
